import { createLiveStore } from "../lib/live-store";
import type { QueueItemDetail } from "../types/api";

interface QueueDetailData {
  item: QueueItemDetail | null;
}

interface QueueDetailExtra {
  queueId: number | undefined;
  setQueueId: (id: number | undefined) => void;
}

export const useQueueDetailStore = createLiveStore<QueueDetailData, QueueDetailExtra>({
  topic: (s) => (s.queueId ? `queue.item.${s.queueId}` : null),
  onSnapshot: (data) => ({ item: data as QueueItemDetail }),
  onEvent: (event) => {
    if (typeof event === "object" && event && "action" in event) {
      const evt = event as { action: string };
      if (evt.action === "deleted") return { item: null };
      return null;
    }
    return null;
  },
  state: (set) => ({
    item: null,
    queueId: undefined,
    setQueueId: (id: number | undefined) => set({ queueId: id, item: null, _loading: true } as any),
  }),
});
